import type { Currency$options } from '$houdini';
import * as m from '$paraglide/messages';

const currencyLabel: Record<Currency$options, () => string> = {
	eur: m.itinerary__options__currency__eur,
	usd: m.itinerary__options__currency__usd,
	gbp: m.itinerary__options__currency__gbp,
	jpy: m.itinerary__options__currency__jpy,
	chf: m.itinerary__options__currency__chf,
	czk: m.itinerary__options__currency__czk,
	dkk: m.itinerary__options__currency__dkk,
	hrk: m.itinerary__options__currency__hrk,
	huf: m.itinerary__options__currency__huf,
	nok: m.itinerary__options__currency__nok,
	pln: m.itinerary__options__currency__pln,
	sek: m.itinerary__options__currency__sek,
	uah: m.itinerary__options__currency__uah,
};

export function currencies(currency: Currency$options): string {
	return currencyLabel[currency]();
}
